import React, { useContext } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useFAQService from '../../../app/services/hooks/useFAQService';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';

interface Props {
    faqId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const FAQSwitchChange = ({ faqId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeFAQ, fetchingActiveFAQ } = useFAQService();

    const active = (value: boolean) => {
        setChecked(value);

        activeFAQ(faqId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={faqId} callback={active} />;
};

export default FAQSwitchChange;

